/**
 * @file Functions for making http requests for order detailed
 * @author Max van Loosbroek
 */

import { IHttpResponse, IHttpService, IPromise } from 'angular'
import { URLS } from '../../../../../common/utilities/constants/constants.module'
import { parseHttpError } from '../../../../../common/utilities/errorHandling'
import { ReturnConcept } from '../types/types'
import { ReturnForm } from '../types/ReturnForm'
import { DetailedTaasOrder } from '../../../../overview/types/types'

export interface SearchParamsReturnConcept {
  clientId?: string
  uuid?: string
  robotSerial?: string
}

export const getReturnConceptsRequest = (
  $http: IHttpService,
  { clientId, uuid, robotSerial }: SearchParamsReturnConcept
): IPromise<IHttpResponse<ReturnConcept[]>> => {
  const params: {
    clientUuid?: string
    clientId?: string
    tessaCode?: string
  } = {}
  if (uuid) params.clientUuid = uuid
  if (clientId) params.clientId = clientId
  if (robotSerial) params.tessaCode = robotSerial
  const url = URLS.admin.taasReturnConcepts
  return $http.get<ReturnConcept[]>(url, { params }).catch(parseHttpError)
}

export const getReturnConceptByIdRequest = (
  $http: IHttpService,
  conceptId: number
): IPromise<IHttpResponse<ReturnConcept>> => {
  const url = `${URLS.admin.taasReturnConcepts}/${conceptId}`
  return $http.get<ReturnConcept>(url).catch(parseHttpError)
}

export const createReturnRequest = (
  $http: IHttpService,
  returnForm: ReturnForm,
  orderId: number
): IPromise<IHttpResponse<DetailedTaasOrder>> => {
  const url = `${URLS.admin.taasOrders}/${orderId}/return`
  return $http.post<DetailedTaasOrder>(url, returnForm).catch(parseHttpError)
}
